<template><svg viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg"><path d="M7.127 10L0 0h14L7.127 10z"/></svg></template>